// extracted by mini-css-extract-plugin
export default {"header":"styles__header___sj8dP"};